import { Box, useMediaQuery } from '@mui/material';
import { Modal } from '@mui/material';
import CookieContent from './content';
import { useDispatch, useSelector } from 'react-redux';
import { setCookieConfig, setPreferenceCenterOpen } from '@/redux/cookieSlice';
import { IoClose } from 'react-icons/io5';
import CookieMobileContent from './mobileContent';

export function ListsyncCookieContentModal() {
  const dispatch = useDispatch();
  const isOpen = useSelector((state: any) => state.cookie.preferenceCenterOpen);

  const handleClose = () => {
    dispatch(setPreferenceCenterOpen(false));
  };
  const style = {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: '#ffffff'
  };
  const isMobile = useMediaQuery('(max-width:1280px)'); // 使用 MUI 的 useMediaQuery

  const component = isMobile ? <CookieMobileContent /> : <CookieContent />;
  return (
    <>
      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        hideBackdrop
      >
        <Box
          sx={style}
          className="absolute h-full w-full bg-white lg:h-[524px] lg:w-[730px] lg:rounded-2xl lg:border lg:border-solid lg:border-[#e2e8f0]"
        >
          <div className="relative flex items-center justify-between border-b border-[#e2e8f0] px-4 py-4 lg:py-2">
            <div className="flex items-center gap-2">
              <img
                src="/listsync/logo.svg"
                alt="logo"
                className="h-6 w-auto lg:hidden"
              />
              <h2 className="text-lg font-semibold lg:text-2xl text-[#1a1a1a]">
                Privacy Preference Center
              </h2>
            </div>
            <IoClose
              className="cursor-pointer text-2xl text-[#64748b] hover:text-[#1a1a1a]"
              onClick={handleClose}
            />
          </div>
          {component}
          <div className="absolute bottom-0 w-full bg-white p-4 lg:relative lg:flex lg:flex-col lg:items-end lg:p-0 lg:pr-8 lg:pb-4 border-t border-[#e2e8f0] lg:border-none">
            <button
              className="flex h-[48px] w-full items-center justify-center rounded-2xl text-white font-semibold transition-all duration-200 lg:w-[220px]"
              style={{
                background: '#3B82F6',
                boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.5)'
              }}
              onClick={() => dispatch(setCookieConfig('' as any))}
            >
              Confirm My Choices
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
